import http from '@/http'

const state = {
  selectId: 0,
  books: [],
  book: null
}

const getters = {
  getSelectId: (state) => {
    return state.book !== null && !!state.book.id ? state.book.id : 0
  },
  selectBook: (state) => {
    return state.book
  }
}

const mutations = {
  setBooks (state, data) {
    state.books = data.books || []
  },
  setBook (state, data) {
    state.book = data.book
  },
  deleteBook (state, data) {
    var index = -1
    for (var i = 0, len = state.books.length; i < len; i++) {
      if (state.books[i].id === data.id) {
        index = i
        break
      }
    }
    if (index > -1) {
      state.books.splice(index, 1)
    }
  }
}

const actions = {
  fetch ({commit}, payload) {
    return http.post('/book/select/', {'page': payload.page, 'limit': payload.limit}).then(function (response) {
      if (response.result && response.body) {
        commit('setBooks', {'books': response.body})
      }
    })
  },
  get ({commit}, payload) {
    return http.post('/book/select/', {'id': payload.id}).then(function (response) {
      if (response.result && response.body) {
        commit('setBook', {'book': response.body})
      }
      return response
    })
  },
  clear ({commit}) {
    commit('setBook', {'book': null})
  },
  insert ({commit}, payload) {
    console.log(payload.book)
    return http.post('/book/insert/', payload.book).then(function (response) {
      return response
    })
  },
  update ({commit}, payload) {
    console.log(payload.book)
    return http.post('/book/update/', payload.book).then(function (response) {
      if (response.result) {
        commit('setBook', {'book': payload.book})
      }
      return response
    })
  },
  delete ({commit}, payload) {
    console.log(payload.id)
    return http.post('/book/delete/', {'id': payload.id}).then(function (response) {
      if (response.result) {
        commit('deleteBook', {'id': payload.id})
      }
      return response
    }).catch(function (error) {
      return error
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Books.js